import Iconify from "@/src/components/iconify/Iconify";

import Link from "next/link";
const QuickActionBlock = ({ title, icon, link }) => {
    return (
        <Link href={link} title={title}>
            <div className="border border-solid border-primary p-1 rounded-full bg-primary hover:scale-110 transition-transform duration-300 ease-in-out group flex items-center gap-2">
                <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center group-hover:bg-primary flex-shrink-0">
                    <Iconify
                        icon={icon}
                        width={36}
                        className="text-primary group-hover:text-white"
                    />
                </div>
                <p className="text-white font-medium text-center flex-1">{title}</p>
            </div>
        </Link>
    );
};

export default QuickActionBlock;
